angular.module('tradersyard').controller('User.Settings.Privacy.Ctrl', [
    '$scope',
    'graph-user-factory',
    'graph-analytic-factory',
    '$flex',
    '$timeout',
    function ($scope, factory, analyticFactory, $flex, $timeout) {
        $scope.node = {};
        $scope.params = {
            page: 0,
        };
        $scope.status = undefined;
        $scope.alert = undefined;
        $scope.accounts = [];
        $scope.space = 'me';

        angular.extend($scope, $flex.data);

        $scope.$on('touch:privacy', function () {
            settings();
        });

        $scope.closeAlert = function () {
            if ($scope.alert) $timeout.cancel($scope.alert);
            $scope.status = undefined;
        };

        function settings() {
            factory.privacyList($scope.space).then(function (response) {
                if (response.data.state === 0 && response.data.data.length > 0) {
                    $scope.settings = response.data.data;
                }
            });

            $timeout(function () {
                analyticFactory.settings($scope.node.id).then(function (response) {
                    if (response.data.state === 0 && response.data.data.length > 0) {
                        $scope.settings[$scope.settings.length - 1].privacy = response.data.data[0].privacy;
                    }
                });
            });
        }

        $scope.update = function (model) {
            factory
                .privacy({
                    settings: [model],
                })
                .then(function (response) {
                    if (response.data.state === 0) {
                        $scope.status = 'Privacy setting was updated';
                    } else {
                        $scope.status = 'Something went wrong...';
                    }
                    $scope.alert = $timeout(function () {
                        $scope.status = undefined;
                    }, 10000);
                });
        };
    },
]);
